/* Intertaal collection banner link + CTA helpers — 10-09-2026 */
(function () {
  var PRODUCT_ANCHOR = 'intertaal-collection-search';
  var CTA_CLASS = 'intertaal-current-collection-cta';
  var CTA_ACTIONS_CLASS = 'intertaal-current-collection-actions';

  var BANNER_LINK_SELECTOR = [
    '.collection-landing-intro__actions a',
    '.collection-landing-intro__shortcuts a',
    '.theme-landing__routes a',
    '.language-landing__routes a',
    '.publisher-landing__routes a',
    '.study-subject-intro__routes a',
    '.' + CTA_CLASS
  ].join(',');

  var CTA_LABELS = {
    'biologie-life-sciences': 'Biologie',
    'business-economie-ai': 'Business, Economie & AI',
    'psychologie': 'Psychologie',
    'recht-legal-english': 'Recht',
    'wiskunde-statistiek': 'Wiskunde & Statistiek',
    'zorg-gezondheid': 'Zorg & Gezondheid',
    'onderwijs-pedagogiek': 'Onderwijs & Pedagogiek',
    'sociale-wetenschappen': 'Sociale Wetenschappen',
    'geschiedenis': 'Geschiedenis',
    'taal-letterkunde': 'Taal & Letterkunde',
    'exacte-wetenschappen': 'Exacte Wetenschappen',
    'filosofie-ethiek': 'Filosofie & Ethiek',
    'kunst-design-media': 'Kunst, Design & Media',
    'geografie-gis': 'Geografie & GIS',
    'studievaardigheden-1': 'Studievaardigheden',
    'engels': 'Engels',
    'duits': 'Duits',
    'frans': 'Frans',
    'spaans': 'Spaans',
    'nederlands': 'Nederlands & NT2',
    'italiaans': 'Italiaans',
    'portugees': 'Portugees',
    'andere-talen': 'Andere talen',
    'romantasy': 'Romantasy',
    'young-adult-boeken': 'Young Adult',
    'herfst-lezen': 'Herfst',
    'winter-feestdagen': 'Winter & Feestdagen',
    'lees-het-seizoen': 'Lees het seizoen',
    'cambridge-up': 'Cambridge',
    'oxford-university-press': 'Oxford',
    'national-geographic-learning-engels-leren-met-impact': 'National Geographic Learning',
    'pearson-english-effectief-engels-leren-voor-elk-niveau': 'Pearson English',
    'klett-sprachen': 'Klett Sprachen',
    'helbling-languages-innovatieve-taalmethode-uitgever-met-visie': 'Helbling Languages',
    'cornelsen-verlag': 'Cornelsen',
    'penguin-engelse-klassiekers-en-literatuur-van-books': 'Penguin Books',
    'penguin-random-house': 'Penguin Random House'
  };

  var HEADER_CONFIGS = [
    { copy: '.study-subject-intro__copy', routes: '.study-subject-intro__routes' },
    { copy: '.language-landing__copy', routes: '.language-landing__routes' },
    { copy: '.theme-landing__copy', routes: '.theme-landing__routes' },
    { copy: '.publisher-landing__copy', routes: '.publisher-landing__routes' }
  ];

  function getCollectionHandle() {
    var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getCtaLabel(handle) {
    if (CTA_LABELS[handle]) return CTA_LABELS[handle];
    var title = document.querySelector('.collection__title');
    return title ? title.textContent.trim() : '';
  }

  function ensureCtaStyles() {
    if (document.getElementById('intertaal-current-collection-cta-styles')) return;

    var style = document.createElement('style');
    style.id = 'intertaal-current-collection-cta-styles';
    style.textContent = [
      '#'+ PRODUCT_ANCHOR +'{scroll-margin-top:104px;}',
      '.'+ CTA_ACTIONS_CLASS +'{display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-top:18px;}',
      '.'+ CTA_CLASS +'{display:inline-flex;min-height:44px;align-items:center;justify-content:center;gap:7px;border-radius:999px;background:#d2701c;padding:11px 20px;color:#fff!important;font-size:12px;font-weight:800;line-height:1.2;text-align:center;text-decoration:none!important;box-shadow:0 6px 14px rgba(210,112,28,.18);transition:transform .18s ease,background .18s ease,box-shadow .18s ease;}',
      '.'+ CTA_CLASS +':hover{background:#bb5f12;color:#fff!important;transform:translateY(-1px);box-shadow:0 8px 18px rgba(210,112,28,.23);}',
      '.'+ CTA_CLASS +':focus-visible{outline:3px solid rgba(210,112,28,.42);outline-offset:3px;}',
      '.'+ CTA_ACTIONS_CLASS +' + .study-subject-intro__routes,.'+ CTA_ACTIONS_CLASS +' + .language-landing__routes,.'+ CTA_ACTIONS_CLASS +' + .theme-landing__routes,.'+ CTA_ACTIONS_CLASS +' + .publisher-landing__routes{margin-top:12px!important;}',
      '@media screen and (max-width:740px){.'+ CTA_ACTIONS_CLASS +'{margin-top:17px;}.'+ CTA_CLASS +'{width:100%;min-height:46px;padding:12px 18px;font-size:12px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureCurrentCollectionCtas() {
    var handle = getCollectionHandle();
    var label = getCtaLabel(handle);
    if (!label) return;

    HEADER_CONFIGS.forEach(function (config) {
      document.querySelectorAll(config.copy).forEach(function (copy) {
        if (copy.querySelector('.' + CTA_ACTIONS_CLASS)) return;

        var actions = document.createElement('div');
        actions.className = CTA_ACTIONS_CLASS;

        var link = document.createElement('a');
        link.className = CTA_CLASS;
        link.href = '#' + PRODUCT_ANCHOR;
        link.appendChild(document.createTextNode('Ga naar ' + label + ' '));

        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.appendChild(arrow);
        actions.appendChild(link);

        var routes = copy.querySelector(config.routes);
        if (routes) {
          copy.insertBefore(actions, routes);
        } else {
          var lead = copy.querySelector('[class$="__lead"]');
          if (lead && lead.nextSibling) {
            copy.insertBefore(actions, lead.nextSibling);
          } else {
            copy.appendChild(actions);
          }
        }
      });
    });
  }

  function scrollToCollectionRoot(collectionRoot) {
    if (!collectionRoot) return;
    collectionRoot.style.scrollMarginTop = '104px';
    collectionRoot.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  function directCollectionLinksToProducts() {
    document.querySelectorAll(BANNER_LINK_SELECTOR).forEach(function (link) {
      if (!link.getAttribute('href')) return;

      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (url.pathname.indexOf('/collections/') !== 0) return;

        url.hash = PRODUCT_ANCHOR;
        link.href = url.pathname + url.search + url.hash;
      } catch (error) {
        /* Leave an invalid or non-standard link untouched. */
      }
    });
  }

  function initCollectionBannerLinks() {
    var collectionRoot = document.querySelector('[data-section-type="collection"]');
    if (collectionRoot && !document.getElementById(PRODUCT_ANCHOR)) {
      collectionRoot.id = PRODUCT_ANCHOR;
    }

    ensureCtaStyles();
    ensureCurrentCollectionCtas();
    directCollectionLinksToProducts();

    if (collectionRoot && window.location.hash === '#' + PRODUCT_ANCHOR) {
      window.requestAnimationFrame(function () {
        scrollToCollectionRoot(collectionRoot);
      });
      window.setTimeout(function () {
        scrollToCollectionRoot(collectionRoot);
      }, 120);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionBannerLinks, { once: true });
  } else {
    initCollectionBannerLinks();
  }

  document.addEventListener('shopify:section:load', initCollectionBannerLinks);
})();
